<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">Preface</h2>
<p class="noindent">It seems much of what we thought was normal about life and the world around us has changed. A tiny virus we can’t see has shut down businesses, crippled nations, and taken the lives of precious people. Those lives can never be replaced. And then there is the petty stuff like finding a single roll of toilet paper at the supermarket.</p>
<p class="indent">We are wearing masks and gloves to protect ourselves and others from this unseen enemy potentially hiding inside our friends, neighbors, and possibly in members of our own family. Normal just isn’t normal anymore. Normal is just a place in our minds that we all seem to want to get back to as soon as possible. Some people are even calling it a new normal, but what is that?</p>
<p class="indent">We’ve decided to take a different path. We’ve decided, in areas where we have a choice, we don’t want to go back to someone else’s definition of normal. We’ve decided we want to go back to better.</p>
<p class="indent">For those of you who have lost loved ones or friends, we are praying for you. As we consider the concept of <i>going back to better</i>, we fully understand that some losses can never be replaced, and in that realm, there is no going back to better. In this book, we are focused on areas where we have a choice whether to go back to normal in those areas or finding our way back to something better.</p>
<p class="indent">Going back to better in those areas means we are not going to just ride this thing out, hoping to limp our way back to normal. Here’s how we see it. No matter what we have had to deal with, we are all going back to one of two futures . . .</p>
<ol class="number">
<li>A future where we are just along for the ride on our way to what the world defines as normal—or—</li>
<li>A future where we want to be more, do more, and give more than ever before. That’s the future we want.</li>
</ol>
<p class="indent">We want to help as many people as possible to discover, re-discover, or refine their purpose in life and create a clear/compelling plan of action to make it happen.</p>
<p class="indent">We didn’t choose to invite this pandemic into our lives, but we want to make the best choices we can going forward. With God’s help, we can!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm05.vue?1d4d91ba